export const newsArticles = [
  {
    title: 'Top 10 New Casino Games Released This Month',
    excerpt: 'Discover the latest and most exciting casino games that have just hit the market. From innovative slots to immersive live dealer experiences, we\'ve tested them all.',
    category: 'Game Reviews',
    date: 'Mar 15, 2026',
    readTime: '5 min read',
    author: 'Sarah Johnson',
    image: 'https://readdy.ai/api/search-image?query=modern%20casino%20gaming%20setup%20with%20multiple%20slot%20machines%20and%20digital%20displays%2C%20bright%20colorful%20game%20screens%20with%20exciting%20graphics%20and%20animations&width=600&height=400&seq=news001&orientation=landscape'
  },
  {
    title: 'How to Maximize Your Casino Bonuses in 2026',
    excerpt: 'Learn expert strategies for getting the most value from casino welcome bonuses, free spins, and loyalty programs. Our comprehensive guide covers everything you need to know.',
    category: 'Strategy Guide',
    date: 'Feb 12, 2026',
    readTime: '8 min read',
    author: 'Michael Chen',
    image: 'https://readdy.ai/api/search-image?query=casino%20bonus%20concept%20with%20golden%20gift%20boxes%20and%20promotional%20offers%2C%20stacks%20of%20casino%20chips%20and%20cash%20rewards%20with%20celebratory%20confetti&width=600&height=400&seq=news002&orientation=landscape'
  },
  {
    title: 'Live Casino Evolution: The Future of Online Gaming',
    excerpt: 'Explore how live dealer technology is revolutionizing the online casino experience with HD streaming, interactive features, and professional dealers.',
    category: 'Industry News',
    date: 'Mar 5, 2026',
    readTime: '6 min read',
    author: 'Emma Williams',
    image: 'https://readdy.ai/api/search-image?query=professional%20live%20casino%20dealer%20in%20modern%20studio%20with%20multiple%20cameras%20and%20high%20tech%20equipment%2C%20elegant%20gaming%20table%20with%20sophisticated%20lighting&width=600&height=400&seq=news003&orientation=landscape'
  }
];